export enum ModoConciliacaoCartaoEnum {
    AssociarCp = 1,
    CriarCp = 2,
    AssociarMovimentacao = 3,
    CriarMovimentacao = 4,
}
